import { SelectableAnswerSlideItemType } from '@llx/common';
import { createContext, useContext } from 'react';

import { ContextType } from '@/@generated/codegen/API';
import { SlideVotingStats } from '@/features/meeting/answer/getSlideVotingStats';

export type TextChangeEvent = {
  answerID: string;
  text: string;
};

type BaseContextType = {
  contextType: ContextType;
  currentSelectedAnswers: string[];
  currentTextAnswers: string[];
  isAnswerConfirmed: boolean;
  hostStats: SlideVotingStats;
  onSelectableAnswerClick: (answerID: string) => void;
  onTextAnswerChange: (events: TextChangeEvent[]) => void;
  onConfirmAnswer: () => void;
  glowingVoteItem: SelectableAnswerSlideItemType | undefined;
  hasAtleastSelectedOneAnswer: boolean;
  slideHasAtLeastOneSelectableAnswer: boolean;
  requestTextAnswerIndex: (answerID: string) => number;
  isSaving: boolean;
  requestShouldBeDisabled: (answerId: string) => boolean;
};

type MeetingQuestionContextType = BaseContextType & {
  contextType: ContextType.Meeting;
};

export const MeetingQuestionContext = createContext<MeetingQuestionContextType | undefined>(
  undefined
);

export const useQuestionContext = () => {
  const meetingContext = useContext(MeetingQuestionContext);

  // if (meetingContext && masterClassContext) {
  //   throw new Error(
  //     'useQuestionContext error: There should not be multiple question context providers'
  //   );
  // }
  if (meetingContext) {
    return meetingContext;
  }
  throw new Error('useQuestionContext must be used within a Question context provider');
};
